module.exports = __webpack_public_path__ + "assets/ceba4e0fd01cad5a1a22f2d6fb1f6849.mp4";